<template>
  <div class="aside-nav">
    <ul>
      <li
        class="header-list-item"
        v-for="(item, index) in navs"
        :key="index"
        :class="item.link == currentNav ? 'active' : ''"
        @click="changeNav(item.link)"
      >
        <router-link :to="item.link" v-if="item.link != '11huodong'">
          <img
            :class="
              item.link == 'materialDownload' ||
              item.link == 'pay' ||
              item.link == '11huodong' ||
              item.link == 'materialCenter'
                ? 'iconfontleft'
                : 'iconfontNone'
            "
            :src="item.icon"
          />
          {{ item.name }}
        </router-link>
        <router-link v-else :to="item.link" target="_blank">
          <img
            :class="
              item.link == 'materialDownload' ||
              item.link == 'pay' ||
              item.link == '11huodong' ||
              item.link == 'materialCenter' ||
              item.link == 'activity'
                ? 'iconfontleft'
                : 'iconfontNone'
            "
            :src="item.icon"
          />
          {{ item.name }}
          <img
            v-if="item.link == '11huodong'"
            class="iconfont"
            :src="newhot"
            alt
            width="30"
          />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  setTempUser,
  setToken,
  setNewUser,
  getNewUser,
} from "../../utils/storage";
export default {
  computed: {
    currentNav() {
      return this.$store.state.menu.asideMenuId == null
        ? ""
        : this.$store.state.menu.asideMenuId;
    },
  },
  data() {
    return {
      navs: [], //导航列表
      asideBanner: require("@/assets/images/asideBanner.png"),
      newhot: require("@/assets/images/da_hot.gif"),
    };
  },
  mounted() {
    this.getNavs();
    //监听事件
    this.$EventBus.$on("getNavs", (data) => {
      if (data == "1") {
        this.getNavs();
      }
    });
  },
  destroyed() {
    this.$EventBus.$off("getNavs");
  },
  methods: {
    //获取导航列表
    getNavs() {
      if (
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0 &&
        this.$store.state.common.userInfo.gender !== 2
      ) {
        this.navs = this.constants.asideMenus1;
      } else {
        this.navs = this.constants.asideMenus;
      }
    },
    //改变导航菜单时切换状态
    changeNav(index) {
      this.$store.commit("headerMenuId", index);
      this.$store.commit("asideMenuId", index);
    },
    goMaterialDownload() {
      this.$router.push({ path: "/materialDownload" });
      this.$store.commit("headerMenuId", "materialDownload");
      this.$store.commit("asideMenuId", "materialDownload");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.aside-nav {
  overflow-x: hidden;
  width: 100%;
  max-width: 400px;
  height: auto;
  background: #f8f8fb;
  box-sizing: border-box;
  z-index: 2;

  ul {
    float: left;
    height: auto;
    min-height: 40px;
    overflow: hidden;
    li {
      margin-bottom: 4px;
      cursor: pointer;
      display: inline-block;
      a {
        display: flex;
        align-items: center;
        margin: 5px 5px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        color: #666;
      }
      &.active {
        a {
          color: rgb(39, 39, 39);
          font-weight: 700;
          background-color: #dcdfe4;
        }
      }
      &:hover {
        a {
          background: #ecedf1;
        }
        .iconfont {
          color: rgb(39, 39, 39);
        }
      }
    }
  }

  .iconfont {
    margin-right: 5px;
    vertical-align: center;
    margin-top: -25px;
  }

  .iconfontleft {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
  }

  .iconfontNone {
    visibility: hidden;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
  }
}
</style>
